//import React, { useEffect, useState } from 'react';
//import { Link } from "react-router-dom";
//import { useSelector } from "react-redux";
//import useAxiosInstance from '../../../services/useAxiosInstance';

//const DashboardPayment = () => {
//  const axiosInstance = useAxiosInstance();
//  const [latestPayment, setLatestPayment] = useState(null);
//  const communityId = useSelector((state) => state.auth.communityId);
//  const clientId = useSelector((state) => state.auth.clientId);


//  useEffect(() => {
//    const fetchPaymentData = async () => {
//      try {
//        const response = await axiosInstance.get(`/api/public/paymentdetail/CommunityIdAndClientId`, {
//          params: {
//            clientId: clientId,
//            communityId: communityId,
//          }
//        });

//        const paymentData = response.data;

//        if (paymentData.length > 0) {
//          const sortedData = paymentData.sort((a, b) => new Date(b.paymentDate || b.createdDate) - new Date(a.paymentDate || a.createdDate));
//          setLatestPayment(sortedData[0]);
//        }
//      } catch (error) {
//        console.error('Error fetching payment data:', error);
//      }
//    };

//    fetchPaymentData();
//  }, [axiosInstance, clientId, communityId]);

//  return (
//    <div className="w-full">
//      <div className="p-5 max-w-3xl mx-auto my-5">
//        <div className="py-4 border-b-2 border-gray-300">
//          <p className="text-2xl text-gray-800 m-0 font-bold">Pending Payments</p>
//        </div>
//        <div className="flex justify-between items-center py-5">
//          <div className="flex-grow-2">
//            {latestPayment ? (
//              <>
//                <h4 className="text-xl mb-2">{latestPayment.reason}</h4>
//                <p className="text-base text-gray-800 my-1">Payment Due - {new Date(latestPayment.paymentDate || latestPayment.createdDate).toLocaleDateString()}</p>
//                <p className="text-base text-gray-800 my-1">$ Amount: <span className='text-green-600 font-bold'>{latestPayment.amount.toFixed(2)}</span></p>
//              </>
//            ) : (
//              <p className="text-base text-gray-800">No payments available.</p>
//            )}
//          </div>
//          <div className="flex-grow-1 text-right">
//            <Link to="/payments-details" className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg no-underline text-lg font-bold text-center shadow-md transition-all duration-300 hover:bg-blue-700 hover:scale-105 active:bg-blue-800 active:scale-100 focus:outline-blue-700 focus:outline-offset-2">
//              <p>View More Details</p>
//            </Link>
//          </div>
//        </div>
//      </div>
//    </div>
//  );
//};

//export default DashboardPayment;

import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import useAxiosInstance from '../../../services/useAxiosInstance';
import { CreditCard, AlertCircle, DollarSign, Calendar, TrendingUp, Users } from 'lucide-react';

const DashboardPayment = ({ startDate, endDate }) => {
    const axiosInstance = useAxiosInstance();
    const [paymentData, setPaymentData] = useState(null);
    const [systemPaymentData, setSystemPaymentData] = useState(null);
    const [loading, setLoading] = useState(false);

    const communityId = useSelector((state) => state.auth.communityId);
    const clientId = useSelector((state) => state.auth.clientId);
    const roleId = useSelector((state) => state.auth.roleId);

    // Check if user should have access to this component
    const hasAccess = () => {
        return roleId === 1000 || roleId === 1003;
    };

    useEffect(() => {
        if (hasAccess()) {
            const fetchPaymentData = async () => {
                setLoading(true);

                try {
                    if (roleId === 1000) {
                        // Superadmin - System-wide payment overview
                        await fetchSystemPaymentOverview();
                    } else if (roleId === 1003) {
                        // User - Personal payment data
                        await fetchPersonalPaymentData();
                    }
                } catch (error) {
                    console.error('Error fetching payment data:', error);
                    setFallbackData();
                } finally {
                    setLoading(false);
                }
            };

            fetchPaymentData();
        }
    }, [roleId, clientId, communityId, startDate, endDate]);

    // Fetch system-wide payment overview for superadmin
    const fetchSystemPaymentOverview = async () => {
        try {
            const response = await axiosInstance.get(`/api/admin/payments/overview`, {
                params: {
                    startDate,
                    endDate
                }
            });

            if (response.data) {
                setSystemPaymentData(response.data);
            } else {
                // Fallback data for superadmin
                setSystemPaymentData({
                    totalPendingAmount: 125650.00,
                    totalPendingCount: 47,
                    totalCollectedAmount: 892300.00,
                    totalCollectedCount: 312,
                    overdueAmount: 23400.00,
                    overdueCount: 12,
                    monthlyGrowth: 8.5,
                    communities: [
                        { name: 'Oak Hills Community', pendingAmount: 15600.00, pendingCount: 8 },
                        { name: 'Pine Valley Estates', pendingAmount: 22300.00, pendingCount: 12 },
                        { name: 'Maple Gardens', pendingAmount: 18900.00, pendingCount: 9 },
                        { name: 'Cedar Ridge HOA', pendingAmount: 31200.00, pendingCount: 15 },
                        { name: 'Willow Creek', pendingAmount: 37650.00, pendingCount: 3 }
                    ]
                });
            }
        } catch (error) {
            console.error('Error fetching system payment overview:', error);
            setFallbackData();
        }
    };

    // Fetch personal payment data for user
    const fetchPersonalPaymentData = async () => {
        try {
            const response = await axiosInstance.get(`/api/public/paymentdetail/CommunityIdAndClientId`, {
                params: {
                    clientId: clientId,
                    communityId: communityId,
                }
            });

            if (response.data && response.data.length > 0) {
                const sortedData = response.data.sort((a, b) =>
                    new Date(b.paymentDate || b.createdDate) - new Date(a.paymentDate || a.createdDate)
                );
                setPaymentData(sortedData[0]);
            } else {
                setPaymentData(null);
            }
        } catch (error) {
            console.error('Error fetching personal payment data:', error);
            setFallbackData();
        }
    };

    // Fallback data based on role
    const setFallbackData = () => {
        if (roleId === 1000) {
            setSystemPaymentData({
                totalPendingAmount: 125650.00,
                totalPendingCount: 47,
                totalCollectedAmount: 892300.00,
                totalCollectedCount: 312,
                overdueAmount: 23400.00,
                overdueCount: 12,
                monthlyGrowth: 8.5,
                communities: [
                    { name: 'Oak Hills Community', pendingAmount: 15600.00, pendingCount: 8 },
                    { name: 'Pine Valley Estates', pendingAmount: 22300.00, pendingCount: 12 },
                    { name: 'Maple Gardens', pendingAmount: 18900.00, pendingCount: 9 }
                ]
            });
        } else if (roleId === 1003) {
            setPaymentData({
                reason: 'Monthly HOA Fees',
                amount: 275.00,
                paymentDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(), // 7 days from now
                createdDate: new Date().toISOString(),
                status: 'Pending'
            });
        }
    };

    // Don't render for unauthorized roles
    if (!hasAccess()) {
        return (
            <div className="w-full p-8 text-center">
                <AlertCircle size={48} className="mx-auto text-gray-400 mb-4" />
                <h3 className="text-lg font-medium text-gray-600 mb-2">Access Restricted</h3>
                <p className="text-gray-500">This component is only available for users and system administrators.</p>
            </div>
        );
    }

    if (loading) {
        return (
            <div className="w-full p-8 text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
                <p className="text-gray-500">Loading payment data...</p>
            </div>
        );
    }

    // Superadmin view - System payment overview
    if (roleId === 1000) {
        return (
            <div className="w-full">
                <div className="p-6 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-t-lg">
                    <div className="flex items-center justify-between">
                        <div>
                            <h2 className="text-2xl font-bold mb-1">Payment Overview - System</h2>
                            <p className="text-blue-100">Financial summary across all communities</p>
                        </div>
                        <CreditCard size={32} className="text-blue-200" />
                    </div>
                </div>

                <div className="bg-white rounded-b-lg shadow-sm">
                    {/* Key Metrics */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-6 border-b">
                        <div className="text-center p-4 bg-green-50 rounded-lg">
                            <DollarSign size={24} className="mx-auto text-green-600 mb-2" />
                            <p className="text-sm text-gray-600 mb-1">Total Collected</p>
                            <p className="text-2xl font-bold text-green-600">
                                ${systemPaymentData?.totalCollectedAmount?.toLocaleString() || '0'}
                            </p>
                            <p className="text-xs text-gray-500">
                                {systemPaymentData?.totalCollectedCount || 0} payments
                            </p>
                        </div>

                        <div className="text-center p-4 bg-yellow-50 rounded-lg">
                            <Calendar size={24} className="mx-auto text-yellow-600 mb-2" />
                            <p className="text-sm text-gray-600 mb-1">Pending Payments</p>
                            <p className="text-2xl font-bold text-yellow-600">
                                ${systemPaymentData?.totalPendingAmount?.toLocaleString() || '0'}
                            </p>
                            <p className="text-xs text-gray-500">
                                {systemPaymentData?.totalPendingCount || 0} payments
                            </p>
                        </div>

                        <div className="text-center p-4 bg-red-50 rounded-lg">
                            <AlertCircle size={24} className="mx-auto text-red-600 mb-2" />
                            <p className="text-sm text-gray-600 mb-1">Overdue Amount</p>
                            <p className="text-2xl font-bold text-red-600">
                                ${systemPaymentData?.overdueAmount?.toLocaleString() || '0'}
                            </p>
                            <p className="text-xs text-gray-500">
                                {systemPaymentData?.overdueCount || 0} payments
                            </p>
                        </div>

                        <div className="text-center p-4 bg-blue-50 rounded-lg">
                            <TrendingUp size={24} className="mx-auto text-blue-600 mb-2" />
                            <p className="text-sm text-gray-600 mb-1">Monthly Growth</p>
                            <p className="text-2xl font-bold text-blue-600">
                                {systemPaymentData?.monthlyGrowth || 0}%
                            </p>
                            <p className="text-xs text-gray-500">vs last month</p>
                        </div>
                    </div>

                    {/* Community Breakdown */}
                    <div className="p-6">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                            <Users size={20} className="mr-2" />
                            Community Payment Status
                        </h3>
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Community</th>
                                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Pending Amount</th>
                                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Pending Count</th>
                                        <th className="px-4 py-3 text-left text-sm font-medium text-gray-600">Status</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {systemPaymentData?.communities?.map((community, index) => (
                                        <tr key={index} className="hover:bg-gray-50">
                                            <td className="px-4 py-3 text-sm text-gray-900">{community.name}</td>
                                            <td className="px-4 py-3 text-sm font-medium text-gray-900">
                                                ${community.pendingAmount?.toLocaleString()}
                                            </td>
                                            <td className="px-4 py-3 text-sm text-gray-900">{community.pendingCount}</td>
                                            <td className="px-4 py-3 text-sm">
                                                <span className={`px-2 py-1 rounded-full text-xs font-medium ${community.pendingAmount > 25000 ? 'bg-red-100 text-red-800' :
                                                        community.pendingAmount > 15000 ? 'bg-yellow-100 text-yellow-800' :
                                                            'bg-green-100 text-green-800'
                                                    }`}>
                                                    {community.pendingAmount > 25000 ? 'High' :
                                                        community.pendingAmount > 15000 ? 'Medium' : 'Low'}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex justify-between items-center p-6 bg-gray-50 rounded-b-lg">
                        <div>
                            <p className="text-sm text-gray-600">System-wide payment management</p>
                        </div>
                        <div className="flex gap-3">
                            <Link
                                to="/admin/payments"
                                className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
                            >
                                Manage All Payments
                            </Link>
                            <Link
                                to="/admin/reports/payments"
                                className="px-4 py-2 bg-gray-600 text-white rounded-lg text-sm font-medium hover:bg-gray-700 transition-colors"
                            >
                                View Reports
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // User view - Personal payment data
    return (
        <div className="w-full">
            <div className="p-5 max-w-3xl mx-auto my-5">
                <div className="py-4 border-b-2 border-gray-300">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-2xl text-gray-800 m-0 font-bold flex items-center">
                                <CreditCard size={24} className="mr-2 text-blue-600" />
                                My Pending Payments
                            </p>
                            <p className="text-sm text-gray-500 mt-1">Your current payment status</p>
                        </div>
                    </div>
                </div>

                <div className="mt-6">
                    {paymentData ? (
                        <div className="bg-gradient-to-r from-blue-50 to-blue-100 border border-blue-200 rounded-lg p-6">
                            <div className="flex justify-between items-start">
                                <div className="flex-grow">
                                    <div className="flex items-center mb-3">
                                        <div className="w-12 h-12 bg-blue-500 text-white rounded-full flex items-center justify-center mr-4">
                                            <DollarSign size={20} />
                                        </div>
                                        <div>
                                            <h4 className="text-xl font-semibold text-gray-800">{paymentData.reason}</h4>
                                            <p className="text-sm text-gray-600">Payment Due</p>
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                        <div>
                                            <p className="text-sm text-gray-600 mb-1">Due Date</p>
                                            <p className="text-base font-medium text-gray-800 flex items-center">
                                                <Calendar size={16} className="mr-2 text-blue-600" />
                                                {new Date(paymentData.paymentDate || paymentData.createdDate).toLocaleDateString()}
                                            </p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-600 mb-1">Amount</p>
                                            <p className="text-2xl font-bold text-green-600">
                                                ${paymentData.amount?.toFixed(2)}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-center justify-between">
                                        <div>
                                            <span className="px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full text-sm font-medium">
                                                {paymentData.status || 'Pending'}
                                            </span>
                                        </div>
                                        <div className="text-right">
                                            <Link
                                                to="/payments-details"
                                                className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg text-sm font-bold hover:bg-blue-700 transition-all duration-300 hover:scale-105 shadow-md"
                                            >
                                                View Details & Pay
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
                            <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                                <CreditCard size={24} />
                            </div>
                            <h3 className="text-lg font-semibold text-green-800 mb-2">All Caught Up!</h3>
                            <p className="text-green-600 mb-4">You have no pending payments at this time.</p>
                            <Link
                                to="/payments-details"
                                className="inline-block px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 transition-colors"
                            >
                                View Payment History
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DashboardPayment;